import React from "react";
import { Grid } from "@mui/material";
import WarningIcon from "../../../resources/images/swisscom-dis-warning-icon.svg";
import InfoIcon from "../../../resources/images/scd-info-icon.svg";
import SectionFullWidthContainer from "../../../ui/layout/page/forms-container/section-full-width-container";
import Image from "../../../ui/widgets/image";
import CustomTypography from "../../../ui/widgets/typography";

export default function WarningBox({
  header,
  text,
  imgAlt,
  isInfo = false,
}: {
  header: string;
  text: string;
  imgAlt: string;
  isInfo?: boolean;
}): React.JSX.Element {
  return (
    <SectionFullWidthContainer hasAdditionalTopMargin={true}>
      <Grid container spacing={4}>
        <Grid size={{ xs: 1 }}>
          {isInfo ? (
            <Image src={InfoIcon} alt={imgAlt} />
          ) : (
            <Image src={WarningIcon} alt={imgAlt} />
          )}
        </Grid>
        <Grid size={{ xs: 11 }}>
          <CustomTypography variant="h3">{header}</CustomTypography>
          <CustomTypography variant="body1">{text}</CustomTypography>
        </Grid>
      </Grid>
    </SectionFullWidthContainer>
  );
}
